<h1 mat-dialog-title>{{ 'STOP-DRAWING-DIALOG.TITLE' | translate }}</h1>
<div mat-dialog-content>
    <p>{{ 'STOP-DRAWING-DIALOG.INFO' | translate }}</p>
</div>
<div mat-dialog-actions>
    <button class="stop-draw-btn" mat-flat-button (click)="stopDrawing()">{{ 'DELETE-ALL-PINS-DIALOG.YES' | translate }}</button>
    <button class="stop-draw-btn" mat-flat-button (click)="cancel()">{{ 'DELETE-ALL-PINS-DIALOG.NO' | translate }}</button>
</div>
